<template>
  <div class="apply">
    <img
      src="../assets/applyprocess/banner.png"
      alt
      style="width: 100%; height: 13.125rem;"
    />
    <div class="navs_container">
      <div class="navs">
        <div
          class="tab"
          v-for="(item, index) in tabs"
          :key="index"
          :style="{
            backgroundColor: index == selectedIndex ? '#0090E3' : '#FFF',
            color: index == selectedIndex ? '#FFF' : '#1A1A1A'
          }"
          @click="changeTab(index)"
          @mouseenter="changeTab(index)"
        >
          <span>{{ item.title }}</span>
        </div>
      </div>
    </div>
    <waterfall
      class="positions"
      :col="2"
      :width="fit - content"
      :gutterWidth="30"
      :data="selectedPositions"
    >
    <template>
        <div class="position_container" v-for="(item,index) in selectedPositions" :key="index">
        <div class="position_title">
          <stroke-text class="my-stroke-text" :text="item.position" :strokes="strokes" />
        </div>
        <div class="desc_container">

            <span class="sub_title">岗位职责</span>
            <div class="div_desc" v-html="item.duty">
            </div>

            <span class="sub_title">任职要求</span>
            <div class="div_desc" v-html="item.requirement">
            </div>
        </div>
      </div>
      </template>
    </waterfall>
  </div>
</template>

<style scoped>

.apply{
  text-align: center;
  padding:0px;
  min-height: 100%;
}

.navs_container{
  width:100%;
  height:3.75rem;
  text-align: center;
  -webkit-box-shadow:0px 3px 3px rgba(3,3,3,0.04);
  -moz-box-shadow:0px 3px 3px rgba(3,3,3,0.04);
  box-shadow:0px 3px 3px rgba(3,3,3,0.04);
  margin-bottom: 3.75rem;
}
.navs{
  width: fit-content;
  display: inline-flex;
	flex-flow: row;
  min-width: 1200px;
}
.tab{
  text-align: center;
  width: fit-content;
  height: 3.75rem;
  line-height:3.75rem;
  padding-left: 6.25rem;
  padding-right: 6.25rem;
}
.tab span{
  font-size: 16px;
  font-weight: bold;
}
img{
  display:block;
}
.positions{
  display: inline-block;
  max-width: 59.5rem;
  min-width: 59.5rem;
}
.position_container{
  width: 90%;
  text-align: center;
  margin-bottom: 3.75rem;
}
.position_title{
  position:relative;
  display: inline-block;
  top: 1.5625rem;
  text-align: center;
  width: fit-content;
  height: fit-content;
  padding: .75rem;
  background-color: #FFA960;
  border:.125rem solid black;
  border-radius: .375rem;
}
.desc_container{
  text-align: center;
  width: fit-content;
  border:.125rem solid black;
  border-radius: .625rem;
  padding-top: 2.875rem;
}


.my-stroke-text{
  color: white;
  font-size: 1rem;
  font-weight: bolder;
}
.sub_title{
  display:inline;
  border-bottom:.375rem solid #FFCAA0;
  font-size: .875rem;
  color: black;
  font-weight:bolder;
}
.div_desc{
  text-align: left;
  margin-top: 1.5625rem;
  margin-bottom:1.5625rem;
  margin-left: 2.375rem;
  margin-right: 2.375rem;
  font-size:.875rem;
  color: black;
  font-weight:600;
}
</style>
<script>
export default {
  data() {
    return {
      W: document.body.clientWidth || document.documentElement.clientWidth,
      msg: "职位速递",
      selectedIndex: 0,
      tabs: [
        {
          title: "运营"
        },
        {
          title: "市场"
        },
        {
          title: "设计"
        },
        {
          title: "产品"
        },
        {
          title: "技术"
        }
      ],
      positions: [
        {
          title: "运营",
          list: [
            {
              position: "广告运营专员",
              duty:
                "1、负责公司自身的广告变现商业化运营工作；<br/>2、对游戏广告形式、场景和竞价策略以及瀑布流设置进行分析和优化；<br/>3、对移动端产品广告位的设计和广告变现策略进行优化。",
              requirement:
                "1、2年以上互联网广告相关经验，具备广告变现产品的运营经验；<br/>2、1年以上竞价广告相关领域的运营经验，有休闲游戏运营经验者优先；<br/>3、熟悉各种广告变现数据指标，对用户价值分析有经验。"
            },
            {
              position: "AM/广告客户专员",
              duty:
                "1、对接海外广告投放合作伙伴，处理广告相关需求；<br/>2、对接渠道代理，维护良好的客户关系，推进客户合作；<br/>3、有效合理调配内外资源，推动项目发展。",
              requirement:
                "1、专科以上学历，具有1年以上广告行业AM工作经验；<br/>2、逻辑思维良好，具备优秀的沟通协调能力、学习能力以及抗压能力；<br/>3、有海外广告相关工作经验者优先考虑。"
            }
          ]
        },
        {
          title: "市场",
          list: [
            {
              position: "海外游戏投放优化师",
              duty:
                "1、针对不同游戏产品制定广告投放机制和策略，管理广告成本，操作广告投放及优化；<br/>2、对渠道及广告创意、数据表现进行分析与总结，不断优化推广效果。",
              requirement:
                "1、专科及以上学历，3年以上海外广告投放经验，英语读写能力佳；<br/>2、熟悉并掌握Facebook/Google等主流投放渠道的操作优化；<br/>3、对数据敏感，有较清晰和完整的数据分析、总结能力。"
            }
          ]
        },
        {
          title: "设计",
          list: [
            {
              position: "平面设计师",
              duty:
                "1、根据项目需求独立完成的设计项目的平面设计需求（包括：海报、上架图、网页等设计）；<br/> 2、熟悉或精通创意海报等各类设计，对视觉设计工作负责，完成各阶段设计需求；<br/> 3、依据运营需求，设计H5活动页面、活动海报、视频等，与项目团队配合，完成工作。",
              requirement:
                "1、大专及以上学历，有1至3年的平面设计经验； <br/> 2、应聘时请携带个人作品集。"
            },
            {
              position: "视频设计师",
              duty:
                "1、负责各类视频，根据设计需求，独立完成视频后期剪辑与特效工作；<br/>2、负责视频相关平面内容设计，对各种素材包括文字、图片、视频等进行有效处理，协助完成创意、制作和包装，对成片质量负责。",
              requirement:
                "1、大专及以上学历，有1-3年相关工作经验，游戏行业经验优先；<br/>2、影视后期、动画、剪辑、摄影、编导等专业优先，精通PR、AE、EDIUS等相关视频编辑软件，合成软件。"
            },
            {
              position: "休闲游戏主美",
              duty:
                "1、项目风格把控，确保美术最终效果； <br/>2、根据项目需求主导美术概念，指导游戏角色，场景，UI,动作特效等美术的设计方案；<br/>3、承担游戏内美术工作计划制定，必要时能完成高质量的制作，保证项目的开发进度。",
              requirement:
                "1、4年以上工作经验，至少一年以上担任过3D游戏美术工作经验，有休闲类游戏美术工作经验者优先； <br/>2、对美术制作流程的各个环节如原画、UI、3D、动画都有掌握和较强的审美感知力； <br/>3、熟悉游戏资源把控优化。"
            }
          ]
        },
        {
          title: "产品",
          list: [
            {
              position: "数值策划",
              duty:
                "1、负责游戏整体数值框架的设计与优化，确保游戏内各数值模块的落地执行； <br/>2、负责游戏内具体功能、玩法的数值设计，并跟进数值的迭代和维护； <br/>3、和测试部门配合，调节具体数值，确保游戏数值的平衡、稳定、安全。",
              requirement:
                "1、3年以上数值策划经验，至少完成过1款上线游戏的数值框架搭建； <br/>2、对游戏数值有自己的认知和理解。"
            },
            {
              position: "休闲游戏主策划",
              duty:
                "1、根据公司发展战略进行游戏核心玩法设计，并制定游戏框架；<br/>2、把控项目整体设计风格，对项目最终品质负责；<br/>3、管理策划组日常工作，指导和培训策划新人。",
              requirement:
                "1、3年以上游戏策划经验，至少经历1个完整项目；<br/>2、对某一特定品类或多个品类的游戏有足够理解，并能独立完成该品类游戏的立项设计；<br/>3、统筹组织能力，熟悉游戏研发各环节。"
            }
          ]
        },
        {
          title: "技术",
          list: [
            {
              position: "U3D主程",
              duty:
                "1. 根据项目设计方案，基于Unity引擎完成项目架构设计；<br/>2. 制定代码规范，审核程序组代码，对项目的客户端开发质量负责；<br/>3. 负责客户端核心功能开发和技术攻关。",
              requirement:
                "1. 5年以上手游客户端开发经验，以主程身份、使用Unity引擎至少经历1个完整项目；<br/>2. 熟悉3D游戏制作流程和规范，了解美术各环节和引擎效果的关系，确保美术效果高效实现；<br/>3. 熟悉Unity引擎封装类的底层语言，熟悉Shader应用，熟悉性能优化。"
            },
            {
              position: "高级JAVA开发工程师",
              duty:
                "1、负责研发公司软件的模块需求分析、设计、开发和交付；<br/>2、负责系统设计、功能编码，单元测试、功能与性能测试。",
              requirement:
                "1、3年以上经验，熟悉Java面向对象开发，熟悉设计模式；<br/>2、掌握Spring boot、spring cloud、MyBatis-Plus等开源框架；<br/>3、有大规模系统设计经验，包括但不限于微服务框架、中间件、服务和存储集群优化方案。"
            }
          ]
        }
      ],
      selectedPositions:[],
      strokes: ["0.175em black"]
    };
  },

  mounted () {
    this.selectedPositions = this.positions[this.selectedIndex].list
   },

  methods: {
    changeTab(index) {
      this.selectedPositions = this.positions[index].list
      this.selectedIndex = index;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Positions.vue